import type { DatasourceSyncRun } from 'c-sdk';

// A run that hasn't started yet has no started_at; it sorts as the newest.
const startedAt = (run: DatasourceSyncRun): number =>
    run.started_at == null ? Infinity : new Date(run.started_at).getTime();

/**
 * The runs worth showing under "Recent syncs", newest first. The API's `syncs` include isn't
 * ordered, so this sorts them itself. A failure older than the latest success has been fixed by
 * that success, so it is left out; one after it is still the table's current problem.
 */
export const recentSyncs = (syncs: DatasourceSyncRun[], limit = 5): DatasourceSyncRun[] => {
    const newestFirst = [...syncs].sort((a, b) => startedAt(b) - startedAt(a) || b.id - a.id);
    const lastSuccess = newestFirst.findIndex(run => run.status === 'succeeded');
    return newestFirst
        .filter((run, i) => lastSuccess === -1 || i <= lastSuccess || run.status !== 'failed')
        .slice(0, limit);
};
